import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withHandlers, setPropTypes, defaultProps } from 'recompose';

import { openJourneyMapModal } from 'redux/modules/journey-map/effects';

const enhance = compose(
  injectIntl,
  connect(null, {
    openJourneyMapModal,
  }),
  setPropTypes({
    idType: PropTypes.string,
    fetchPosition: PropTypes.bool,
  }),
  defaultProps({
    idType: 'journey',
    fetchPosition: false,
    forceGoogleMaps: false,
  }),
  withHandlers({
    handleClick:
      ({ forceGoogleMaps, fetchPosition, idType, item, openJourneyMapModal }) =>
      (e) => {
        e.stopPropagation();
        openJourneyMapModal({
          item,
          idType,
          fetchPosition,
          forceGoogleMaps,
        });
      },
  })
);

export default enhance;
